module.exports = __webpack_public_path__ + "img/bg_login_2.d3830334.png";